export enum LocalStorage {
	PosUUID = "pos-UUID",
}
